import ActionStatus from '@sunbit-dev/common/enums/ActionStatus';
import IApplicationError from '@sunbit-dev/common/models/IApplicationError';
import { Actions, ActionTypes } from '../actions/documentActions';
import IDocument from '@sunbit-dev/common/models/IDocument';

export interface IDocumentState extends Partial<IDocument> {
  type?: ActionTypes;
  status?: ActionStatus;
  error?: IApplicationError;
}

const initialState: IDocumentState = {
}

export default function documentReducer(state = initialState, action: Actions): IDocumentState {
  switch(action.type) {
    case ActionTypes.LoadStaticDocument:
      return {...state, ...action};
    default:
      return state;
  }
}
